
var content = require("!!../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/css-loader/dist/cjs.js!../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/media-query-plugin/src/loader.js!../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/sass-loader/dist/cjs.js??ref--1-3!./_color-drawer.scss");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/css-loader/dist/cjs.js!../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/media-query-plugin/src/loader.js!../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/sass-loader/dist/cjs.js??ref--1-3!./_color-drawer.scss", function() {
		var newContent = require("!!../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/css-loader/dist/cjs.js!../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/media-query-plugin/src/loader.js!../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/sass-loader/dist/cjs.js??ref--1-3!./_color-drawer.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}